import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ClassNameProp, LabelProp } from '@swf/core/types/Props';

import { TXTCLI_Create_Account } from './Ghost.messages.json';
import { ghost } from './Ghost.scss';

type Props = Partial<LabelProp> & ClassNameProp;

const Ghost: React.FunctionComponent<Props> = ({
  label = TXTCLI_Create_Account,
  children,
  className
}) => {
  const intl = useIntl();

  return (
    <div className={classNames(ghost, className)}>
      <span>{intl.formatMessage(label)}</span>
      {children}
    </div>
  );
};

export default Ghost;
